export const TOGGLE_EDIT_STATUS = "TOGGLE_EDIT_STATUS"; //切换编辑状态
export const SET_LAYOUTS = "SET_LAYOUTS"; //设置layouts
export const SET_DRAGGING_ITEMS = "SET_DRAGGING_ITEMS"; //设置正在拖拽的item
export const CLEAR_DATA = "CLEAR_DATA"; // 清空数据
export const UPDATE_SHADOWCARD = "UPDATE_SHADOWCARD"; // 更新
export const UPDATE_GROUP_LIST = "UPDATE_GROUP_LIST"; //更新GroupList数据
export const UPDATE_CURREDITID = "UPDATE_CURREDITID"; //更新正在编辑的分组ID
export const INIT_GROUPS = "INIT_GROUPS"; //初始化时候的Groups
export const JSON = "JSON"; //多语
export const UPDATE_SELECTED_CARDS = "UPDATE_SELECTED_CARDS"; //更新左侧已选卡片
export const UPDATE_HOMEPAGE = "UPDATE_HOMEPAGE"; //更新首页内容
export const SET_EMPTY = "SET_EMPTY"; // 是否无应用
export const TOGGLE_DEDUPLICATE_MODAL = "TOGGLE_DEDUPLICATE_MODAL"; // 显示去重弹窗
export const SET_DROPPABLE = "SET_DROPPABLE"; //设置GridLayout是否可drop
export const SET_GRID_MARGIN = "SET_GRID_MARGIN"; //设置桌面间隔
export const SET_GROUP_DRAGABLE = "SET_GROUP_DRAGABLE"; //设置分组拖拽状态
export const SET_APP_GROUP_DATA = "SET_APP_GROUP_DATA"; //设置聚合应用数据
export const SET_DRAGGING_APPGROUP_ITEM = "SET_DRAGGING_APPGROUP_ITEM"; //设置正在拖拽的聚合应用item
export const SET_HELP_HINT = "SET_HELP_HINT"; //设置帮助信息显示状态
export const SET_DROPPED_ITEM = "SET_DROPPED_ITEM"; //设置放置的聚合应用
export const SET_DEFAULT_APP_GROUP_DATA = "SET_DEFAULT_APP_GROUP_DATA"; //设置默认聚合数据
export const SET_SAVE_COMPLETE_FLAG = "SET_SAVE_COMPLETE_FLAG"; //设置保存成功标识
export const UPDATE_LAYOUT_FLAG = "UPDATE_LAYOUT_FLAG"; //设置更新布局标识
export const SET_SIDER_COLLAPSED = "SET_SIDER_COLLAPSED"; //设置左栏收起状态
export const SET_LEFT_HELPTIP = "SET_LEFT_HELPTIP"; //设置左栏帮助提示显隐
export const SAVE_EXTERNAL_LINK_DATA = "SAVE_EXTERNAL_LINK_DATA"; //常用链接数据
export const IS_RESP_WORKBENCH = "IS_RESP_WORKBENCH"; // 是否职责桌面
export const SET_DRAGOVER_GROUP = "SET_DRAGOVER_GROUP"; // dragOver的分组
export const UPDATE_EDITING_SIDER_STATUS = "UPDATE_EDITING_SIDER_STATUS"; // 是否存在正在编辑的侧边栏
export const SET_WORKBENCH_CONFIG = "SET_WORKBENCH_CONFIG"; // 工作台全局配置
export const UPDATE_APP_PROPERTIES = "UPDATE_APP_PROPERTIES"; // 更新layout-app属性